import deDefault from './default/de.json';
import enDefault from './default/en.json';
import deInvoicing from './invoicing/de.json';
import enInvoicing from './invoicing/en.json';

export enum Language {
  de = 'de',
  en = 'en',
}

export enum Namespace {
  default = 'default',
  invoicing = 'invoicing',
}

export const i18nResources: {
  [key in Language]: { [key in Namespace]: { [key: string]: string } };
} = {
  [Language.de]: {
    [Namespace.default]: deDefault,
    [Namespace.invoicing]: deInvoicing,
  },
  [Language.en]: {
    [Namespace.default]: enDefault,
    [Namespace.invoicing]: enInvoicing,
  },
};
